/* eslint-disable no-shadow */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { FormGroup } from 'react-bootstrap';
import Autocomplete from 'react-google-autocomplete';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import { getFormattedAddress } from '../../infrastructure/utils/common';
import '../../styles/containers/Activity.css';

const StyledFormGroup = styled(FormGroup)`
  display: inline-block;
  width: 210px;
  padding-right: 0px;
  margin-right: 20px;

  @media (max-width: 768px) {
    width: 120px;
    margin-bottom: 8px;
    margin-right: 10px;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const SearchLocationForm = ({ search, textChange, value, disabled }) => {
  const handleChange = ({ target }) => {
    const { value } = target;
    if (!value) search('');
    textChange(value);
  };

  const placeSelected = val => {
    const param = getFormattedAddress(val);
    search(param);
  };

  return (
    <StyledFormGroup>
      {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        <Autocomplete
          className='form-control'
          placeholder='Location'
          disabled={disabled}
          onPlaceSelected={placeSelected}
          onChange={handleChange}
          value={value}
        />
      }
    </StyledFormGroup>
  );
};

export default React.memo(SearchLocationForm);
